import { ApiResult, request, safeRequest } from '@synergy/api';
import { DocumentType, ReceiptAlert } from '@synergy/models';
import { getUrlSegment } from '@synergy/utils';

export class ReceiptAlertApi {
    constructor(protected baseUrl: string) {}

    public updateAlert = async (
        documentType: DocumentType,
        id: number,
        alert: ReceiptAlert
    ): Promise<ApiResult<null>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/${getUrlSegment(documentType)}/${id}/update-alert`, alert),
            response => response.data
        );
    };

    public deleteAlert = async (documentType: DocumentType, id: number): Promise<ApiResult<null>> => {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/${getUrlSegment(documentType)}/${id}/delete-alert`),
            response => response.data
        );
    };
}
